import * as React from "react";
import BasePopup from "../../../popups/BasePopup.jsx"
import { styled } from "@mui/material/styles";

const StyledDataList = styled('dl')({
  borderCollapse: "collapse",
  width: "100%",
  "& > :nth-of-type(odd)": {
    backgroundColor: "rgba(150, 150, 150, 0.2)",
  },
  "& div": {
    display: "flex",
    marginRight: "1rem",
  },
  "& div dt": {
    flexShrink: 0,
    fontWeight: "bold",
    width: "120px",
    paddingLeft: "5px",
  },
  "& div dd": {
    flexGrow: 1,
    marginLeft: 0,
    paddingLeft: "10px",
    paddingRight: "5px",
  },
})

const renderDataList = (title, rows, first=false) => {
  return (
    <>
      <h2 style={{
        marginTop: 0,
        padding: first ? 0 : "1rem 0 0 0",   
      }}>
        {title}
      </h2>
      <StyledDataList>
        {rows.map(([label, value]) => renderDataListItem(label, value))}
      </StyledDataList>
    </>
  )
}

const renderDataListItem = (label, value) => {
  return (
    <div key={label}>
      <dt>{label}</dt>
      <dd>{value}</dd>
    </div>
  )
}

const formatDate = (vDate) => {
  if (!vDate) {
    return ''
  }

  if (typeof vDate === 'number') {
    const date = new Date(vDate)
    return date.toLocaleDateString("en-UK").split(",")[0]
  }

  return ''
}


const PersistentlyVacantPopop = ({data}) => {
  const props = data.properties;

  return (
    <BasePopup
      coords={data.coords}
      offset={1}
      anchor="bottom"
      maxWidth="480px"
      style={{
        color: "black",
        fontSize: "13px",
        width: "auto",
        height: "465px",
        overflowY: "hidden",
      }}>

        <div style={{
            paddingLeft: "1rem",
            marginTop: "0.5rem",
            width: "100%",
            maxHeight: "calc(455px - 2rem)", // Account for popup box margins
            overflowY: "scroll",
        }}>

            <img src={props.image} style={{width: '100%'}}/>

            {renderDataList("Vacancy details", [
                ["Duration of last vacancy", props.duration_of_latest_vancancy_day],
                ["Date last vacancy began", formatDate(props.date_latest_vacancy_began)],
                ["Cumulative Vacancy (past 2 yrs))", props.cumulative_vacancy_in_the_past_],
                ["No. vacancy periods (past 2 yrs)", props.number_of_vacancies_in_the_past],
            ], true)}


            {renderDataList("Organisation", [
                ["Last tenant", props.former_tenant],
                ["Last use class", props.former_business_cat],
            ], true)}

            {renderDataList("Building", [
                ["Floor space sq m", props.floorspace_m2],
                ["Verification date", formatDate(props.date_of_last_desk_survey)], // ?
            ])}

            {renderDataList("Address", [
                ["UPRN", props.uprn],
                ["LDC Premises ID", props.premises_id],

              ["Address", props.address],
        ])}
      </div>
    </BasePopup>
  )

}

const ExperianRetailLocationPopup = ({ data }) => {

  if (data.layerId === "hsds-experian-retail-locations-persistently-vacant"){
    return <PersistentlyVacantPopop data={data} />
  }
  const props = data.properties;

  return (
    <BasePopup
      coords={data.coords}
      offset={1}
      anchor="bottom"
      maxWidth="480px"
      style={{
        color: "black",
        fontSize: "13px",
        width: "auto",
        height: "410px",
        overflowY: "hidden",
      }}>

      <div style={{
        paddingLeft: "1rem",
        marginTop: "0.5rem",
        width: "100%",
        maxHeight: "calc(400px - 2rem)", // Account for popup box margins
        overflowY: "scroll",
      }}>
          {renderDataList("Organisation", [
              ["Name", props.tenant],
              ["Group name", props.company_holding],
              ["Category", props.classification],
              ["Use class", props.category],
              ["Sub class", props.subcategory],
              ["Independent?", props.flag_independent ? 'Yes' : 'No'],
          ], true)}

          {renderDataList("Building", [
              ["Floor space sq m", props.area_sm],
              ["Verification date", formatDate(props.date_last_survey_office)], // ?
          ])}

        {renderDataList("Address", [
              ["Address 1", props.address],
              ["Address 2", props.street],
              ["Postcode", props.zip],
        ])}
      </div>
    </BasePopup>
  )
}

export default ExperianRetailLocationPopup;